import { useCallback, useState } from "react";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "simplydo/react/ui/button";
import { H2, Subheader } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";
import { Message } from "simplydo/react/ui/message";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

function ForgottenPassword() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const email = useAppSelector((state) => state.entry.email);
  const organisation = useAppSelector(
    (state) => state.organisations.urlOrganisation,
  );

  const dispatch = useAppDispatch();
  const setEmail = useCallback(
    (value: string) => {
      dispatch(actions.entry.updateEmail(value));
    },
    [dispatch],
  );

  const navigate = useNavigate();

  const sendEmail = useCallback(() => {
    if (!email) {
      return;
    }
    setLoading(true);
    api.auth.sendPasswordResetEmail(
      email,
      organisation?._id ?? "",
      () => {
        setLoading(false);
        toast(t("entry.forgottenPassword.sent"));
        navigate("/");
      },
      (err) => {
        setLoading(false);
        toast.error(err.message);
      },
    );
  }, [email, organisation, navigate, t]);

  return (
    <div>
      <H2>
        {t("entry.forgottenPassword.title")}
        <Subheader>{t("entry.forgottenPassword.info")}</Subheader>
      </H2>
      <Message color="orange">
        Please remember to check your spam or junk mail folder if you don’t
        receive the email in your inbox
      </Message>
      <Input
        fluid
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("placeholder.email")}
        autoFocus
      />
      <div style={{ marginTop: 30, textAlign: "right" }}>
        <Button onClick={() => navigate("..")} variant="outline">
          {t("generic.back")}
        </Button>
        <Button onClick={sendEmail} loading={loading} color="primary">
          {t("entry.forgottenPassword.send")}
        </Button>
      </div>
    </div>
  );
}

export default ForgottenPassword;
